import { PoComboOption } from '@po-ui/ng-components';
import { FilterComplex, OperatorEnum } from 'src/app/shared/models/filtercomplex.model';

export class ComponentesUtils{

  public convertToArrayComboOption(items: Array<any>, fieldName: string): Array<PoComboOption> {
    if (items && items.length > 0) {
      return items.map(item => this.convertToComboOption(item, fieldName));
    }
    return undefined;
  }

  public convertToComboOption(item, fieldName: string): PoComboOption {
    item = item || {};
    return {
      value: item || undefined,
      label: item[fieldName] || undefined
    };
  }

  public FilterEqualConcatenated(filterComplex: Array<FilterComplex>): string {
    if(filterComplex.length == 1)
    {
      return filterComplex[0].filterEqualForNumberValue;
    }
    else {
      let filterConcat = '';
      const lastItem = filterComplex.slice(-1)[0];
      filterComplex.forEach(x => {
        if(x == lastItem)
          filterConcat += `${lastItem.filterEqualForNumberValue}`
        else
          filterConcat += `${x.filterEqualForNumberValue} or `
      })
      return filterConcat;
    }
  }

  public FilterStartsWithConcatenated(filterComplex: Array<FilterComplex>): string {
    if(filterComplex.length == 1)
    {
      return filterComplex[0].filterStartWiths;
    }
    else {
      let filterConcat = '';
      const lastItem = filterComplex.slice(-1)[0];
      filterComplex.forEach(x => {
        if(x == lastItem)
          filterConcat += `${lastItem.filterStartWiths}`
        else
          filterConcat += `${x.filterStartWiths} or `
      })
      return filterConcat;
    }
  }

  public FiltersWithOperatorEnum(filterComplex: Array<FilterComplex>): string {
    if(filterComplex.length == 1)
    {
      return this.validateOperatorFilter(filterComplex[0]);
    }
    else {
      let filterConcat = '';
      const lastItem = filterComplex.slice(-1)[0];
      filterComplex.forEach(filter => {
        if(filter == lastItem)
          filterConcat += this.validateOperatorFilter(lastItem);
        else
          filterConcat += this.validateOperatorFilter(filter) + ' or ';
      })
      return filterConcat;
    }
  }

  private validateOperatorFilter(filter: FilterComplex) :string
  {
    switch(filter.operator) {
      case OperatorEnum.Equals: {
        return filter.filterEqualForStringValue;
      }
      case OperatorEnum.StartWiths: {
        return filter.filterStartWiths;
      }
      case OperatorEnum.Contains: {
        return filter.filterContains;
      }
      default: {
        return '';
      }
    }
  }
}

